/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CatalogIconType {
	Default = 0,
	Uploaded = 1,
	ModelParameter = 2,
}
